import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { HiArrowRight } from 'react-icons/hi';

const InsightsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  const articles = [
    {
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=800&q=80',
      category: 'Leadership',
      date: 'December 2025',
      title: 'How to Build High-Performing Teams Without Burnout',
      excerpt: 'Discover the key strategies that allow teams to maintain peak performance while prioritizing well-being.',
    },
    {
      image: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=800&q=80',
      category: 'Well-being',
      date: 'November 2025',
      title: 'The Future of Leadership: Why Well-being Matters',
      excerpt: 'Explore why the most successful organizations are putting employee well-being at the center of their strategy.',
    },
    {
      image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&w=800&q=80',
      category: 'Management',
      date: 'October 2025',
      title: '5 Leadership Mistakes That Impact Team Performance',
      excerpt: 'Learn about the common pitfalls leaders face and how to avoid them for better team outcomes.',
    },
  ];

  return (
    <section
      id="insights"
      ref={ref}
      data-testid="insights-section"
      className="section-padding bg-[#FDFBF7]"
    >
      <div className="container-main">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="flex flex-col md:flex-row md:items-end md:justify-between mb-12"
        >
          <div>
            <p className="overline text-[#7A8B71] mb-4">Blog</p>
            <h2 className="heading-2 text-[#0A192F]" data-testid="insights-headline">
              Insights on Leadership<br />& Well-being
            </h2>
          </div>
          <button className="btn-secondary mt-6 md:mt-0" data-testid="insights-view-all">
            View All Articles
            <HiArrowRight className="w-4 h-4" />
          </button>
        </motion.div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {articles.map((article, index) => (
            <motion.article
              key={index}
              initial={{ opacity: 0, y: 40 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              className="group cursor-pointer"
              data-testid={`article-card-${index + 1}`}
            >
              {/* Image */}
              <div className="aspect-[4/3] rounded-lg overflow-hidden mb-6">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              {/* Meta */}
              <div className="flex items-center gap-3 mb-3">
                <span className="overline text-[#7A8B71]">{article.category}</span>
                <span className="w-1 h-1 bg-[#4A5568] rounded-full" />
                <span className="text-sm text-[#4A5568]">{article.date}</span>
              </div>

              {/* Title */}
              <h3 className="heading-3 text-[#0A192F] mb-3 group-hover:text-[#7A8B71] transition-colors">
                {article.title}
              </h3>

              {/* Excerpt */}
              <p className="body-text text-[#4A5568]">
                {article.excerpt}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InsightsSection;
